import React from "react";
import { BallIndicator } from "react-native-indicators";

import { colors } from "asset/constant";
import { mq } from "utils";
import { ViewStyle } from "react-native";

export default function Loading(props: LoadingT & { style?: ViewStyle }) {
  const { color, size, style } = props;

  return (
    <BallIndicator
      color={color || colors.theme}
      size={size || mq(35)}
      style={style}
      {...props}
    />
  );
}
